module.exports = __webpack_public_path__ + "static/img/FullBodyXRAY14.96019ffd.jpg";